import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Id, toast } from "react-toastify";
import { Err } from "samuel-types";

// The InitialState For The Slice
const initialState: {
  tripsInfo: Drivn.TripInfoShort[];
  loading: boolean;
  error?: Err;
  start: string;
  end: string;
  alreadyDispatched: boolean;
} = {
  tripsInfo: [],
  loading: false,
  error: undefined,
  start: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toString(),
  // Tomorrow's date
  end: new Date(Date.now() + 24 * 60 * 60 * 1000).toString(),
  alreadyDispatched: false
};

// The Authentication Redux Slice
const tripsSlice = createSlice({
  name: "trips",
  initialState: initialState,
  reducers: {
    startTripsUpdate(state) {
      state.loading = true;
      return state;
    },
    tripsError: (
      state,
      newValue: PayloadAction<[import("samuel-types").Err, Id | undefined]>
    ) => {
      if (newValue.payload[1]) {
        toast.update(newValue.payload[1], {
          render: newValue.payload[0].message,
          type: "error",
          isLoading: false,
          autoClose: 5000
        });
      } else {
        // Toast
        toast.error(newValue.payload[0].message);
      }

      // Setting The State
      return {
        ...state,
        loading: false,
        error: newValue.payload[0],
        alreadyDispatched: true
      };
    },
    setTrips(
      state,
      newValue: PayloadAction<Drivn.TripInfoShort[]>
    ) {
      state.tripsInfo = newValue.payload;
      state.loading = false;
      state.error = undefined;
      state.alreadyDispatched = false;
      return state;
    },
    setDates: (
      state,
      newValue: PayloadAction<{ start: Date; end: Date }>
    ) => {
      state.start = newValue.payload.start.toString();
      state.end = newValue.payload.end.toString();
      
      state.tripsInfo = [];

      return state;
    }
  }
});
// Exporting The Actions
export const {
  setTrips,
  tripsError,
  startTripsUpdate,
  setDates
} = tripsSlice.actions;

// Exporting The Slice
export default tripsSlice;
